import { CollapsedCard } from "~/shared/ui/Card/ui/CollapsedCard";

export const Card = {
  Collapsed: CollapsedCard,
};
